import {
  CLEAR_ACCOUNT_SEARCH,
  SET_ACCOUNTS,
  SET_SELECTED_ACCOUNT,
  SET_SELECTED_PURCHASE,
  SET_ACCOUNT_REINSTATE_INFO,
} from 'constants/accountSearch';

const INITIAL_STATE = { accounts: [], selectedAccount: {} };

const accountSearch = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ACCOUNTS:
      return { accounts: action.accounts, selectedAccount: {} };
    case SET_SELECTED_ACCOUNT:
      return { ...state, selectedAccount: action.account };
    case SET_SELECTED_PURCHASE:
      return { ...state, selectedPurchase: action.purchase };
    case SET_ACCOUNT_REINSTATE_INFO:
      return {
        ...state,
        selectedAccount: {
          ...state.selectedAccount,
          reinstateReason: action.reinstateReason,
          canReinstateAccount: action.canReinstateAccount,
          extraParams: action.extraParams,
        },
      };
    case CLEAR_ACCOUNT_SEARCH:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default accountSearch;
